// Beautiful, fixed-size share graphic for a Calculation Canvas.
// Rendered off-screen and exported to PNG (html-to-image). Optimised for
// WhatsApp/Instagram: 1080x1350-ish portrait, DealAlert brand look.
import React from "react";

function eur(v) {
  if (v == null || v === "") return "—";
  if (typeof v !== "number") return String(v);
  return `€ ${Math.round(v).toLocaleString("de-AT")}`;
}

export function CalculationShareCard({ widget }) {
  const w = widget || {};
  const share = w.share || {};
  const rows = share.rows || [];
  const delta = share.delta;
  const verdict = share.verdict;
  const conf = w.confidence;

  return (
    <div
      data-testid="calc-share-card"
      style={{
        width: 1080,
        minHeight: 1350,
        background: "#0a0a0a",
        color: "#fafafa",
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        padding: "72px 64px",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      {/* brand */}
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 48 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: "#f59e0b",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 26, fontWeight: 800, color: "#0a0a0a" }}>D</div>
        <div style={{ fontSize: 30, fontWeight: 700, letterSpacing: -0.5 }}>DealAlert</div>
        <div style={{ marginLeft: "auto", fontSize: 22, color: "#f59e0b", fontWeight: 600 }}>
          {share.headline || "AI Analyse"}
        </div>
      </div>

      {/* subject */}
      <div style={{ fontSize: 62, fontWeight: 800, lineHeight: 1.05, marginBottom: 8 }}>
        {share.subject || w.title}
      </div>
      {share.route && (
        <div style={{ fontSize: 30, color: "#a1a1aa", marginBottom: 48 }}>{share.route}</div>
      )}

      {/* rows */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 32 }}>
        {rows.map((r, i) => (
          <div key={i} style={{
            display: "flex", justifyContent: "space-between", alignItems: "baseline",
            padding: "22px 0", borderBottom: "1px solid #27272a",
          }}>
            <span style={{ fontSize: 34, color: "#a1a1aa" }}>{r.label}</span>
            <span style={{
              fontSize: 46, fontWeight: 700,
              color: r.accent === "amber" ? "#f59e0b" : "#fafafa",
            }}>{eur(r.value)}</span>
          </div>
        ))}
      </div>

      {/* delta hero */}
      {delta?.value != null && (
        <div style={{
          borderRadius: 24, padding: "36px 40px", marginBottom: 28,
          background: delta.direction === "positive" ? "rgba(16,185,129,0.12)" : "rgba(244,63,94,0.12)",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <span style={{ fontSize: 40, fontWeight: 700,
            color: delta.direction === "positive" ? "#34d399" : "#fb7185" }}>
            {delta.direction === "positive" ? "💰 " : "⚠️ "}{delta.label}
          </span>
          <span style={{ fontSize: 72, fontWeight: 800,
            color: delta.direction === "positive" ? "#34d399" : "#fb7185" }}>
            {eur(delta.value)}
          </span>
        </div>
      )}

      {/* verdict */}
      {verdict && (
        <div style={{
          borderRadius: 20, padding: "28px 40px", textAlign: "center", marginBottom: 28,
          fontSize: 44, fontWeight: 800,
          background: verdict.tone === "positive" ? "rgba(16,185,129,0.18)" : "rgba(244,63,94,0.18)",
          color: verdict.tone === "positive" ? "#34d399" : "#fb7185",
        }}>
          {verdict.tone === "positive" ? "✅ " : "❌ "}{verdict.label}
        </div>
      )}

      {/* confidence */}
      {conf && (
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: "auto" }}>
          <span style={{ fontSize: 30 }}>
            {conf.level === "high" ? "🟢" : conf.level === "medium" ? "🟡" : "⚪"}
          </span>
          <span style={{ fontSize: 28, color: "#d4d4d8" }}>
            AI Confidence {conf.score} %
          </span>
        </div>
      )}

      {/* footer */}
      <div style={{ marginTop: 40, paddingTop: 28, borderTop: "1px solid #27272a",
        display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 26, color: "#71717a" }}>
          {share.footer || "Berechnet mit DealAlert AI"}
        </span>
        <span style={{ fontSize: 26, color: "#f59e0b", fontWeight: 600 }}>dealalert.ai</span>
      </div>
    </div>
  );
}
